import React from 'react';
import Cookies from 'js-cookie';
import {accountsAlertCookie} from './consts';
import {AccountsDialog} from './AccountsDialog';

export async function renderAccountsDialog(root) {
    const accountsDialogShown = Cookies.get(accountsAlertCookie);
    if (accountsDialogShown) {
        return null;
    }
    root.render(<AccountsDialog />);
}
